<template>
    <div class="container-fluid-grid">

        <transition name="mode" mode="out-in">
            <div v-if="mode.taker === 'easy'" key="easy">
                <div class="form-row">
                    <div class="col-12" style="min-height: 100vh">
                        <br>
                        <br>
                        <div class="d_f a-i_c j-c_c">
                            <div style="width:100%; max-width: 700px">
                                <div class="t-c">
                                    <label for="invoiceEditSelectCustomer">Procurar Cliente</label>
                                </div>
                                <Autocomplete id="invoiceEditSelectCustomer"
                                              v-model="customerName"
                                              placeholder="Informe o nome, cnpj ou cpf"
                                              url="/v1/invoices/search_customers?criteria="
                                              :input-class="'form-control'"
                                              :on-select-item="returnValue"
                                              :item-value-presentation="itemValuePresentation"
                                              :item-presentation="itemPresentation"/>
                            </div>
                        </div>

                        <div class="t-c">
                            <div class="or">OU</div>
                            <button type="button"
                                    class="btn btn-theme-1" @click="mode.taker = 'edit'">Informar Manualmente <svg-icon icon="chevron-right"/></button>
                        </div>
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
            </div>
            <div v-if="mode.taker === 'edit'" :key="'edit'">
                <div class="form-row">
                    <div class="form-group col-12 col-md-2">
                        <label for="invoiceEditCompetence" class="required">Competência</label>
                        <div class="input-group input-group-sm">
                            <input type="text"
                                   id="invoiceEditCompetence"
                                   v-model="entity.competence"
                                   class="form-control form-control-sm t-c plch-center n-m-r-right"
                                   :class="{'is-invalid': errors.competence}"
                                   placeholder="DD/MM/AAAA"
                                   v-flatpickr
                                   v-mask="'##/##/####'">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <svg-icon icon="calendar-alt"/>
                                </div>
                            </div>
                        </div>
                        <field-messages :errors="errors.competence"/>
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="invoiceEditCompetence" class="required">Tipo Pessoa</label><br>
                        <div style="margin-top: 3px">
                            <div class="form-check form-check-inline">
                                <input class="form-check-inline radio m green"
                                       v-model="entity.document_type"
                                       type="radio"
                                       @change="entity.document = null"
                                       id="invoiceEditCia"
                                       value="cnpj">
                                <label class="form-check-label c-p" for="invoiceEditCia">{{$appUtils.isDesktop() ? 'Jurídica' : 'PJ'}}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input radio m green"
                                       v-model="entity.document_type"
                                       type="radio"
                                       @change="entity.document = null"
                                       id="invoiceEditPeople"
                                       value="cpf">
                                <label class="form-check-label c-p" for="invoiceEditPeople">{{$appUtils.isDesktop() ? 'Física' : 'PF'}}</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input radio m green"
                                       v-model="entity.document_type"
                                       type="radio"
                                       @change="entity.document = null"
                                       id="invoiceEditUnknown"
                                       value="nothing">
                                <label class="form-check-label c-p" for="invoiceEditUnknown">Não Informado</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-2 col-6" v-if="entity.document_type !== 'nothing'">
                        <label for="invoiceEditDoc" class="required">{{entity.document_type === 'cnpj' ? 'CNPJ' : 'CPF'}}</label>
                        <input id="invoiceEditDoc"
                               class="form-control form-control-sm"
                               :class="{'is-invalid': errors.document}"
                               type="text"
                               placeholder="Somente números"
                               maxlength="18"
                               v-mask="entity.document_type === 'cnpj' ? '##.###.###/####-##' : '###.###.###-##'"
                               v-model="entity.document">
                        <field-messages :errors="errors.document"/>
                    </div>
                    <div class="form-group col-md-2 col-6" v-if="entity.document_type !== 'nothing'">
                        <label for="invoiceEditInscricaoMunicipal">Inscrião Municipal</label>
                        <input id="invoiceEditInscricaoMunicipal"
                               class="form-control form-control-sm"
                               :class="{'is-invalid': errors.incricao_municipal}"
                               type="text"
                               placeholder="Somente números"
                               maxlength="18"
                               v-mask="'###############'"
                               v-model="entity.incricao_municipal">
                        <field-messages :errors="errors.incricao_municipal"/>
                    </div>
                    <div class="form-group col-md-4" v-else>
                        <label></label><br>
                        <div style="margin-top: 3px">
                            <div class="form-check form-check-inline">
                                <input class="form-check-inline checkbox m green"
                                       v-model="taker_type"
                                       type="checkbox"
                                       id="invoiceEditTypeTaker">
                                <label class="form-check-label c-p" for="invoiceEditTypeTaker">{{taker_type ? 'Sem CPF' : 'Exterior'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 col-12">
                        <label for="invoiceEditTakerName" class="required">{{entity.document_type === 'cnpj' ? 'Razão Social' : 'Nome do Tomador'}}</label>
                        <div class="container-customer">
                            <input id="invoiceEditTakerName"
                                   class="form-control form-control-sm not-b-r-top-right not-b-r-bottom-right"
                                   :class="{'is-invalid': errors.taker_name}"
                                   type="text"
                                   maxlength="125"
                                   v-model="entity.taker_name">
                            <button type="button"
                                    @click="() => {
                                        mode.taker = 'easy';
                                        customerName= '';
                                        $emit('onReset')
                                    }"
                                    class="btn btn-sm btn-theme-1 not-b-r-top-left not-b-r-bottom-left"><svg-icon icon="search"/> Procurar</button>
                        </div>
                        <field-messages :errors="errors.taker_name"/>
                    </div>
                    <div class="form-group col-md-2 col-4">
                        <label for="invoiceEditPhone">Telefone</label>
                        <input id="invoiceEditPhone"
                               class="form-control form-control-sm"
                               :class="{'is-invalid': errors.phone}"
                               placeholder="Somente números"
                               autocomplete="off"
                               type="text"
                               v-mask="['(##) ####-####', '(##) # ####-####']"
                               v-model="entity.phone">
                        <field-messages :errors="errors.phone"/>
                    </div>
                    <div class="form-group col-md-4 col-8">
                        <label for="invoiceEditEmail">E-mail</label>
                        <input id="invoiceEditEmail"
                               class="form-control form-control-sm"
                               placeholder="cliente@dominio.com.br"
                               :class="{'is-invalid': errors.email}"
                               type="email"
                               v-model="entity.email">
                        <field-messages :errors="errors.email"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-1 col-3">
                        <label for="invoiceEditPostalCode" class="required">CEP</label>
                        <input id="invoiceEditPostalCode"
                               class="form-control form-control-sm"
                               :class="{'is-invalid': errors.postal_code}"
                               autocomplete="off"
                               @keyup="searchPostalCode($event)"
                               type="text"
                               v-mask="'#####-###'"
                               v-model="entity.postal_code">
                        <field-messages :errors="errors.postal_code"/>
                    </div>
                    <div class="form-group col-md-4 col-9">
                        <label for="invoiceEditAddress" class="required">Endereço</label>
                        <input id="invoiceEditAddress"
                               class="form-control form-control-sm"
                               :class="{'is-invalid': errors.address}"
                               type="text"
                               maxlength="125"
                               v-model="entity.address">
                        <field-messages :errors="errors.address"/>
                    </div>
                    <div class="form-group col-md-2 col-3">
                        <label for="invoiceEditAddressNumber" :class="{required: entity.document_type === 'cnpj'}">Nº</label>
                        <input id="invoiceEditAddressNumber"
                               class="form-control form-control-sm"
                               :class="{'is-invalid': errors.address_number}"
                               type="text"
                               maxlength="10"
                               v-model="entity.address_number">
                        <field-messages :errors="errors.address_number"/>
                    </div>
                    <div class="form-group col-md-2 col-9">
                        <label for="invoiceEditAddressNotes">Complemento</label>
                        <input id="invoiceEditAddressNotes"
                               class="form-control form-control-sm"
                               placeholder="Apto, Casa, Sala, etc"
                               :class="{'is-invalid': errors.address_notes}"
                               type="text"
                               maxlength="60"
                               v-model="entity.address_notes">
                        <field-messages :errors="errors.address_notes"/>
                    </div>
                    <div class="form-group col-md-3 col-12">
                        <label for="invoiceEditNeighborhood">Bairro</label>
                        <input id="invoiceEditNeighborhood"
                               class="form-control form-control-sm"
                               :class="{'is-invalid': errors.neighborhood}"
                               type="text"
                               maxlength="60"
                               v-model="entity.neighborhood">
                        <field-messages :errors="errors.neighborhood"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-2 col-4">
                        <label for="invoiceEditCountry" class="required">País</label>
                        <select id="invoiceEditCountry"
                                :disabled="'cpf|cnpj'.indexOf(entity.document_type) > -1 || taker_type"
                                class="form-control form-control-sm"
                                @change="loadStates"
                                v-model="country_id">
                            <option v-for="c in countries" :key="c.id" :value="c.id">{{c.name}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3 col-8">
                        <label for="invoiceEditState" class="required">Estado</label>
                        <select id="invoiceEditState"
                                class="form-control form-control-sm"
                                @change="loadCities"
                                v-model="entity.state_code">
                            <option v-for="s in states" :key="s.id" :value="s.acronym">{{s.name}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3 col-12">
                        <label for="invoiceEditCity" class="required">Cidade</label>
                        <select id="invoiceEditCity"
                                class="form-control form-control-sm"
                                v-model="entity.city_ibge_code">
                            <option v-for="c in cities" :key="c.id" :value="c.ibge_code">{{c.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import Autocomplete from "../../components/particles/Autocomplete";

    export default {
        name: "TakerServiceTab",
        components:{Autocomplete},
        props: {
            entity: {
                type: Object,
                default: {}
            },
            errors: {
                type: Object,
                default: {}
            },
            mode: {
                type: Object,
                default: {}
            },
            selectedProposals: {
              type: Object,
              default: {}
            }
        },
        data() {
            return {
                taker_type: true,
                country_id: 1/*Brasil*/,
                customerName: '',
                countries: [],
                states: [],
                cities: [],
                cachePostalCode: {},
            }
        },
        methods: {
            loadInvoiceData(customer_id, invoice_id = null) {
                this.$appHttp.get(`/v1/invoices/load_invoice_data/${invoice_id ? invoice_id : customer_id}?search_type=${invoice_id ? 'invoice' : 'customer'}`)
                    .then(({data}) => {
                      Object.keys(data).forEach(k => {
                        if (invoice_id) {
                          if (!['cities', 'proposals'].includes(k) && this.entity[k] !== undefined) {
                            if (k === 'competence' && data[k]) {
                              const [year, month, day] = data[k].split('-');
                              this.$set(this.entity, k, `${day}/${month}/${year}`);
                            } else {
                              this.$set(this.entity, k, data[k]);
                            }
                          }
                        } else {
                          const unsetList = ['cities', 'proposals', 'total', 'description', 'operation_nature', 'service_code', 'number', 'total_value', 'unconditional_discount_value', 'ir_value', 'iss_value', 'csll_value', 'cofins_value', 'pis_value', 'competence'];

                          if (!unsetList.includes(k) && this.entity[k] !== undefined) this.$set(this.entity, k, data[k]);
                        }
                      });

                      if (data.proposals && invoice_id) {
                        for (const proposal of data.proposals) {
                          this.$set(this.selectedProposals, proposal.id, proposal);
                        }
                      }

                      if (invoice_id) this.$set(this.entity, 'replace_id', invoice_id);

                      this.cities = data.cities;
                      this.mode.taker = 'edit';
                    })
                    .catch(console.error);
            },
            loadCountries() {
                this.$appHttp.get('/v1/location/load_countries')
                    .then(({data}) => this.countries = data)
                    .catch(console.error);
            },
            loadStates() {
                this.$appHttp.get(`/v1/location/load_states/${this.country_id}`)
                    .then(({data}) => this.states = data)
                    .catch(console.error);
            },
            loadCities() {
                const state = this.states.filter(s => s.acronym === this.entity.state_code);
                const url = ['/v1/location/load_cities'];

                if (state.length > 0) url.push('/', state[0].id);
                this.cities = [];

                this.$appHttp.get(url.join(''))
                    .then(({data}) => {
                        this.cities = data;
                        const hasIbge = data.filter(c => c.ibge_code === this.entity.city_ibge_code);
                        if (data && data.length > 0 && hasIbge.length === 0)
                            this.entity.city_ibge_code = data[0].ibge_code
                    })
                    .catch(console.error);
            },
            setAddress(data) {
                this.entity.city_ibge_code = data.neighborhood.city.ibge_code;
                this.entity.state_code = data.neighborhood.city.state.acronym;
                this.entity.neighborhood = data.neighborhood.name;
                this.entity.address = data.address;
                this.loadCities();
            },
            searchPostalCode(e) {
                const postal_code = (e.target.value || '').replace(/\D+/, '');

                if (postal_code.length === 8) {
                    if (this.cachePostalCode[postal_code]) this.setAddress(this.cachePostalCode[postal_code]);
                    else {
                        this.$appHttp.get(`/v1/location/search_postal_code/${postal_code}`)
                            .then(({data}) => {
                                this.$set(this.cachePostalCode, postal_code, data);
                                this.setAddress(data)
                            })
                            .catch(({response}) => {
                                this.$appUtils.vibrate();

                                console.error(response);
                                if (response.status === 404) this.$snotify.warning('CEP não encontrado', this.$appStorage.getUser().name);
                            })
                    }
                }
            },
            returnValue(obj) {
                this.customerName = obj.name;

                this.loadInvoiceData(obj.id);
            },
            itemPresentation(obj, val) {
                const regex = new RegExp((val || '').trim(), 'gi');
                const name = this.$appUtils.highlightText(obj.name, regex);
                const city_name = this.$appUtils.highlightText(obj.city.name, regex);
                const state_acronym = this.$appUtils.highlightText(obj.city.state.acronym, regex);

                let document = 'SEM DOCUMENTO';
                let doc_len = 0;

                if (obj.document) {
                    document = this.$appUtils.highlightText(this.$appUtils.formatDocument(obj.document), regex);
                    doc_len = obj.document.length;
                }

                return ['<div class="ellipsis f-w-700">', name, '</div>', '<div style="font-size: .8em" class="ellipsis">', (doc_len === 14 ? 'CNPJ' : 'CPF'),': ', document, ' | CIDADE: ', city_name, '/', state_acronym, '</div>'].join('');
            },
            itemValuePresentation: obj => obj.name
        },
        mounted() {
            this.loadCountries();
            this.loadStates();
            this.loadCities();

            if (this.$route.query.invoice_id && this.$route.query.mode === "replace") {
              this.loadInvoiceData(this.$route.params.id, this.$route.query.invoice_id);
            }
        }
    }
</script>

<style scoped lang="scss">

    .or {
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 2em;
    }

    .container-customer {
        display: grid;
        grid-template-columns: 1fr 100px;
    }

    .mode-enter-active, .mode-leave-active {
        transition: all .2s ease-in-out;
    }
    .mode-enter {
        transform: translateX(50px);
        opacity: 0;
    }
    .mode-leave-to {
        transform: translateX(-50px);
        opacity: 0;
    }
</style>
